import { useGetRenewVisaDocumentInfo, useGetRenewVisaUploadFileDocumentInfo } from "@/api/services/main/renew-visa";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { TopPage } from "@/components/elements/TopPage";
import { UploadApplicationForm } from "@/features/renew-visa/components/applicationStep/uploadApplication/UploadApplicationForm";
import { useGetUploadFileListWithFilterCondition } from "@/features/renew-visa/hook/useGetUploadFileListWithFilterCondition";
import { convertResToUploadApplicationFormData } from "@/features/renew-visa/utils/convertResToUploadApplicationFormData";
import { AppRoutes } from "@/routes/config";
import { FCC } from "@/types/common";
import { DOCUMENT_STATUS, RENEW_VISA_DOCUMENT_STATUS } from "@/types/enum";
import { getDynamicRoute } from "@/utils/url";
import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";

type TRenewVisaPresentUploadApplicationPageProps = {};

export const RenewVisaPresentUploadApplicationPage: FCC<TRenewVisaPresentUploadApplicationPageProps> = ({}) => {
  const { employeeRenewVisaDocumentGroupId, documentStepId } = useParams();

  const { data: renewVisaDocument, isLoading: isLoadingRenewVisaDocument } = useGetRenewVisaDocumentInfo();

  const { data: uploadFileData, isLoading: isLoadingUploadFile } = useGetRenewVisaUploadFileDocumentInfo({
    documentStepId: documentStepId ?? "",
    enabled: !!documentStepId,
  });

  const [isEditable, setIsEditable] = useState(false);

  const { filterConditionArrayKeys, isLoading: isLoadingUploadFileListWithFilterCondition } = useGetUploadFileListWithFilterCondition();

  useEffect(() => {
    if (!uploadFileData) {
      setIsEditable(true);
    } else {
      if (uploadFileData.status === DOCUMENT_STATUS.IN_PROGRESS) {
        setIsEditable(true);
      } else if (uploadFileData.status === DOCUMENT_STATUS.COMPLETE) {
        setIsEditable(false);
      }
    }
  }, [uploadFileData]);

  const isLoading = useMemo(
    () => isLoadingUploadFile || isLoadingUploadFileListWithFilterCondition || isLoadingRenewVisaDocument,
    [isLoadingUploadFile, isLoadingUploadFileListWithFilterCondition || isLoadingRenewVisaDocument],
  );

  const isFinishRenewVisaDocument = useMemo(
    () =>
      !!renewVisaDocument?.status &&
      [RENEW_VISA_DOCUMENT_STATUS.WITHDRAWN, RENEW_VISA_DOCUMENT_STATUS.REJECTED, RENEW_VISA_DOCUMENT_STATUS.COMPLETE].includes(
        renewVisaDocument?.status,
      ),
    [renewVisaDocument],
  );

  if (isLoading) return <LoadingPage />;
  return (
    <>
      <TopPage
        title="添付書類"
        isDraft={uploadFileData?.isDraft}
        backUrl={getDynamicRoute(AppRoutes.renewVisaPresent, { employeeRenewVisaDocumentGroupId })}
        description="対象の外国人の在留期間更新に必要な書類一覧です。適切な書類をPDFにした上でアップロードください。"
      />
      <UploadApplicationForm
        readonly={isFinishRenewVisaDocument}
        status={uploadFileData?.status}
        previousValues={convertResToUploadApplicationFormData(filterConditionArrayKeys, uploadFileData)}
        isExistUploadFileData={!!uploadFileData}
        isEditable={isEditable}
        setIsEditable={setIsEditable}
      />
    </>
  );
};
